import {
  IconDownload,
  IconHelpingHand,
  IconLockOpenOutline,
  IconEuro,
} from '@iwoca/icons';
import { Button, Tooltip } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { LayoutHeadings } from 'components/Layout/InnerLayout/LayoutHeadings/LayoutHeadings';
import { FLEXI_LOAN_DE_URL } from 'components/ProductItems/products/productGuidesLinks';
import { ComparisonTable } from '../../ComparisonTable/ComparisonTable';
import { FeatureHighlight } from '../../FeatureHighlight/FeatureHighlight';
import sharedStyles from '../../Products.module.css';
import { useFlexiKreditFeaturesTable } from './FlexiKreditFeatures.helpers';
import styles from './FlexiKreditFeatures.module.css';

export const FlexiKreditFeatures = () => {
  const { data, labels, hideCommissionRows } = useFlexiKreditFeaturesTable();

  return (
    <div className={clsx(sharedStyles.section, styles.container)}>
      <Button
        variant="secondary-alt"
        className={styles.pdfButton}
        href={FLEXI_LOAN_DE_URL}
        target="_blank"
        rel="noreferrer"
      >
        <IconDownload />
        <Trans>Download PDF</Trans>
      </Button>

      <LayoutHeadings
        heading={t`Flexi-Loan`}
        headingVariant="long"
        headingAlignment="center"
      />

      <div className={sharedStyles.highlights}>
        <FeatureHighlight
          icon={IconEuro}
          feature={t`Flexible loans up to 500,000 €`}
        />
        <FeatureHighlight
          icon={IconLockOpenOutline}
          feature={
            <span className={styles.featureWithTooltip}>
              {t`Unsecured loans`}
              <Tooltip
                content={t`For corporations, a self-debt guarantee is required.`}
              />
            </span>
          }
        />
        <FeatureHighlight
          icon={IconHelpingHand}
          feature={t`Early repayments and partial settlements are possible at any time at no cost.`}
        />
      </div>

      <div className={styles.tableWrapper}>
        <ComparisonTable data={data} labels={labels} />
      </div>

      <div className={styles.footnoteContainer}>
        <p className={styles.footnote}>
          <Trans>
            * Corresponds, for example, to a total cost of 1.9% amounting to
            12.78% over 12 months with linear repayment.
          </Trans>
        </p>
        <div className={styles.footnoteItalic}>
          <p className={styles.footnote}>
            <Trans>
              Offer conditions are determined in the credit analysis.
            </Trans>
          </p>
          {!hideCommissionRows && (
            <p className={styles.footnote}>
              <Trans>
                For loans paid out to the distribution partner themselves as the
                loan applicant, iwoca does not pay a brokerage commission.
              </Trans>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
